import React from 'react';
import * as S from './UserPoolRow.styles';
import { IPoolProperties } from '../IdentityProviders';

export type UserPoolRowProps =  & {
    isSelected: boolean;
    onRadioChange: (userPoolId: string) => void;
    isCurrentSelection: boolean;
    userPool: IPoolProperties;
}

const UserPoolRow = ({ userPool, isSelected, onRadioChange, isCurrentSelection }: UserPoolRowProps) => {
    return (
        <S.RowContainer isSelected={isSelected} isDisabled={!userPool.available} onClick={() => userPool.available && onRadioChange(userPool.userPoolId)}>
            <S.RadioWrapper isSelected={isSelected}>
                <S.RadioInput
                    type="radio"
                    name="poolSelection"
                    checked={isSelected}
                    readOnly={true}
                />
            </S.RadioWrapper>
            <S.PoolNameText isSelected={isSelected}>{userPool.userPoolName}</S.PoolNameText>
            <S.Separator>|</S.Separator>
            <S.RowTextWrapper>
                <S.PoolIdRowText>{userPool.userPoolId}</S.PoolIdRowText>
                <S.DomainNameRowText>{userPool.userPoolSaml2Url}</S.DomainNameRowText>
            </S.RowTextWrapper>
            {isCurrentSelection ? (
                <S.RowStatusText>Current Selection</S.RowStatusText>
            ) : !userPool.available ? (
                <S.RowStatusText>Unavailable</S.RowStatusText>
            ) : null}
        </S.RowContainer>
    );
};

export default UserPoolRow;
